import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@anduin/auth';
import { ConfirmationModalComponent, ConfirmationPayload, PluralizePipe } from '@anduin/shared';
import { firstValueFrom, from } from 'rxjs';
import { invoicesQueries } from './data';

@Injectable({ providedIn: 'root' })
export class InvoicesDialogsService {
  private readonly dialog = inject(MatDialog);
  private readonly authService = inject(AuthService);
  private readonly pluralize = inject(PluralizePipe);

  private readonly bulkDownloadMutation = invoicesQueries.bulkDownload();

  /**
   * Opens confirmation modal for bulk invoice download.
   * Triggers API call on confirm and returns true if successful.
   */
  async confirmBulkDownload(invoiceIds: number[]): Promise<boolean> {
    const email = this.authService.getUid();

    const dialogRef = this.dialog.open<ConfirmationModalComponent, ConfirmationPayload, boolean>(ConfirmationModalComponent, {
      data: {
        title: `Download ${this.pluralize.transform(invoiceIds.length, 'invoice')}?`,
        message: `An email will be sent to <strong>${email}</strong> when the download is ready with a link to download the file(s). This may take several minutes.`,
        confirmButtonText: 'Process Download',
        confirmButtonColor: 'primary',
        asyncConfirmationAction: () => from(this.bulkDownloadMutation.mutateAsync(invoiceIds)),
      },
    });

    return (await firstValueFrom(dialogRef.afterClosed())) ?? false;
  }
}
